'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultProps = exports.propTypes = exports.config = undefined;

var _spauiUtils = require('@tencent/spaui-utils');

/**
 * Watermark 接口参数
 * @property {titleline} 默认支持参数
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {string} url='' 可以通过图片地址或者通过style.backgroundImage自行设置水印图片
 */
var config = exports.config = {
    url: {
        type: _spauiUtils.PropTypes.string.isRequired,
        defaultValue: ''
    }
};

// 转化成PureComponent组件的配置
/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
/**
 * @fileoverview 组件参数配置
 */

var configData = (0, _spauiUtils.formatProps)(config);
// 导出
var propTypes = exports.propTypes = configData.propTypes;
var defaultProps = exports.defaultProps = configData.defaultProps;

exports.default = {
    config: config,
    propTypes: propTypes,
    defaultProps: defaultProps
};